import React from 'react';

import {fetchEventExhibitors} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadExhibitors = ({eventId, children}) => {
    useStoredDataChanged();
    return (
        <Loader skipSpinner={state => state.events[eventId]?.exhibitors.loaded} promises={[fetchEventExhibitors(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadExhibitors;
